import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { Testimonials } from "@/sections/Testimonials";

export default function TestimonialsPage() {
  return (
    <main data-testid="testimonials-page" className="pt-10">
      <Navbar />
      <CartDrawer />
      <section className="px-5 pb-24 pt-24 md:px-10 md:pb-32 md:pt-32">
        <div className="mx-auto max-w-[1400px]">
          <p className="eyebrow mb-4">Testimonianze</p>
          <h1 className="max-w-5xl font-display text-6xl font-900 uppercase leading-[0.85] md:text-8xl">
            Storie <span className="text-[#c4dcca]">vere.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-base text-[#a3b1aa] md:text-lg">
            Le parole di chi sta facendo il percorso.
          </p>
          <Testimonials />
        </div>
      </section>
      <Footer />
    </main>
  );
}
